import React, { Component } from 'react'
import { connect } from 'react-redux'
import { autobind } from 'react-decoration'
import styled from 'styled-components'
import SideBar from '@components/sideBar'
import TabSwitcher from '@components/tabSwitcher'
import { Button } from '@components/input'
import TextField from '@components/textField'

import { actions } from 'mindself-api-client'
const { UserActions } = actions

const NavBarContainer = styled.div`
  background-color: #ffffff;
  height: 80px;
  padding: 0 128px;
  display: flex;
  align-items: center;
`

const Logo = () => {
  return (
    <img
      src="./assets/Mindself_logo.png"
      alt="web_logo"
      width="170px"
      height="40px"
    />
  )
}

const Right = styled.div`
  margin-left: auto;
  display: flex;
  align-items: center;
`

const ButtonContainer = styled.div`width: 128px;`

const NavBar = () => {
  return (
    <NavBarContainer>
      <Logo />
      <Right>
        <ButtonContainer>
          <Button color="#909090" noBorder text="Download" />
        </ButtonContainer>
        <ButtonContainer>
          <Button noBorder text="Login" />
        </ButtonContainer>
        <ButtonContainer>
          <Button primary text="Sign Up Free" />
        </ButtonContainer>
      </Right>
    </NavBarContainer>
  )
}

const LandingPageContainer = styled.div`
  height: 100vh;
  background-color: #f4f4f7;
`

const Main = styled.div`
  height: calc(100% - 80px);
  padding: 0 128px;
  display: flex;
  align-items: center;
`

const Content = styled.div`
  width: 50%;
  display: flex;
  justify-content: center;
`

const LeftContent = Content.extend`
  padding-bottom: 27px;
  flex-wrap: wrap;
`

const RightContent = Content.extend`padding-bottom: 20px;`

const LargeText = styled.h3`
  font-size: 72px;
  margin: 0;
  color: #474747;
  width: 100%;
`

const MediumText = styled.h5`
  font-size: 36px;
  color: rgba(0, 0, 0, 0.56);
  margin: 0;
  padding-bottom: 8px;
  font-weight: normal;
`

const SmallText = styled.p`
  font-size: 17px;
  color: rgba(0, 0, 0, 0.56);
  margin: 0;
  padding-top: 16px;
  width: 100%;
`

const CommentText = styled.span`
  font-size: 12px;
  color: rgba(0, 0, 0, 0.4);

  & > a {
    color: #4a90e2;
    cursor: pointer;
  }
`

const SignupFormWrapper = styled.div`
  background-color: #ffffff;
  padding: 64px;
  width: 488px;
`

const TextFieldWrapper = styled.div`margin-top: 24px;`

const SignupButtonWrapper = styled.div`margin: 32px 0 24px;`

@connect(null, UserActions)
class LandingPage extends Component {
  state = {
    email: '',
    username: '',
    password: '',
  }
  @autobind
  handleChange(field) {
    return value => {
      this.setState(() => ({ [field]: value }))
    }
  }
  @autobind
  async handleSubmit() {
    const { email, username, password } = this.state
    const { requestRegister, register } = this.props
    await requestRegister('email', email)
    const verify =
      '31000000000000004cf2913a935d18ff9d9de67d26a732bf7a2d5162a17dbfe2243695876d173b83'
    const res = await register(verify, username, password)
    console.log(res)
  }
  render() {
    const { email, username, password } = this.state
    return (
      <LandingPageContainer>
        <NavBar />
        <Main>
          <LeftContent>
            <LargeText>
              Your <br /> Augmented <br /> Intelligence
            </LargeText>
            <SmallText>Keep everything you love in Mindself</SmallText>
          </LeftContent>
          <RightContent>
            <SignupFormWrapper>
              <MediumText>Sign Up Free</MediumText>
              <TextFieldWrapper>
                <TextField
                  title="EMAIL"
                  value={email}
                  onChange={this.handleChange('email')}
                />
              </TextFieldWrapper>

              <TextFieldWrapper>
                <TextField
                  title="USERNAME"
                  value={username}
                  onChange={this.handleChange('username')}
                />
              </TextFieldWrapper>

              <TextFieldWrapper>
                <TextField
                  password
                  title="PASSWORD"
                  value={password}
                  onChange={this.handleChange('password')}
                />
              </TextFieldWrapper>

              <SignupButtonWrapper>
                <Button primary text="Sign Up Free" />
              </SignupButtonWrapper>

              <CommentText>
                By clicking Sign Up Free, you agree to our
                <a>Term of Service</a> and <a>Privacy Policy</a>
              </CommentText>
            </SignupFormWrapper>
          </RightContent>
        </Main>
      </LandingPageContainer>
    )
  }
}

export default LandingPage



// WEBPACK FOOTER //
// ./src/pages/landing.js